class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);

    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
      document.dispatchEvent(new CustomEvent("cart-drawer:opened"));
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    document.dispatchEvent(new CustomEvent("cart-drawer:closed"));
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

let freeShippingUnlocked = false;
//Free Shipping Progress Bar
function updateShippingMessage(cartData = null) {
  const messageEl = document.getElementById("shipping-message");
  
  // Check if the element exists before proceeding
  if (!messageEl) {
    return; // Exit early if element doesn't exist
  }
  
  const threshold = parseFloat(messageEl.dataset.threshold);
  
  // Get cart total from the event data if available, otherwise fall back to dataset
  let cartTotal;
  if (cartData && cartData.cartData) {
    cartTotal = cartData.cartData.total_price / 100; // Convert from cents to dollars
  } else {
    cartTotal = parseFloat(messageEl.dataset.cartTotal);
  }

  let remaining = threshold - cartTotal;

  if (remaining > 0) {
    messageEl.innerHTML = `You are <span id="shipping-amount">£${remaining.toFixed(2)}</span> away from free shipping`;
    freeShippingUnlocked = false;
   
  } else {
    
    messageEl.innerHTML = `Congratulations! You've unlocked <span>Free Shipping</span>`;

    const truck = document.querySelector('.truck-wrapper');
    const confetti = document.querySelector('.confetti');

    if (truck && confetti) {
      truck.classList.add('active');
      confetti.classList.add('pop');

      // remove confetti after animation so it can trigger again next time
      setTimeout(() => confetti.classList.remove('pop'), 1000);
      freeShippingUnlocked = true;
    }
  }
}
// function updateProgressBar(cartTotal, threshold) {
//   const progressBarLine = document.querySelector('.spb-progress-bar-line');
//   if (!progressBarLine) return;

//   let progress = (cartTotal / threshold) * 100;
//   if (progress > 100) progress = 100;
//   if (progress < 0) progress = 0;

//   // Shift bar based on progress
//   progressBarLine.style.transform = `translateX(${progress - 100}%)`;
  
// }

function updateProgressBar() {
  console.log("updateProgressBar");
  const messageEl = document.getElementById("shipping-message");
  const progressLine = document.querySelector(".spb-progress-bar-line");

  if (!messageEl || !progressLine) return;

  const threshold = parseFloat(messageEl.dataset.threshold);
  const cartTotal = parseFloat(messageEl.dataset.cartTotal);

  if (isNaN(threshold) || threshold <= 0) return;

  // Calculate percentage
  let percent = (cartTotal / threshold) * 100;

  // Cap at 100%
  if (percent > 100) percent = 100;

  requestAnimationFrame(() => {
    progressLine.style.width = percent + "%";
  });

}


function setupCartUpdateListener() {
  subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    updateProgressBar();
    updateShippingMessage(event); // Pass the event data
  });
}

document.addEventListener("cart-drawer:opened", () => {
  // Add a small delay to ensure cart data is fully rendered in Safari
    updateProgressBar();
    updateShippingMessage();
    document.querySelector(".kl-teaser-QVqkx9").classList.add("hidden");
});

document.addEventListener("cart-drawer:closed", () => {
  document.querySelector(".kl-teaser-QVqkx9").classList.remove("hidden");
});

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    setupCartUpdateListener();
    updateProgressBar();
    updateShippingMessage(); // Call on initial load
  });
} else {
  setupCartUpdateListener();
  updateProgressBar();
  updateShippingMessage(); // Call on initial load
}
